module.exports = __webpack_public_path__ + "img/IBM - explorer.45a47115.png";